import { render, staticRenderFns } from "./base-header.vue?vue&type=template&id=038fa141&"
import script from "./base-header.vue?vue&type=script&lang=js&"
export * from "./base-header.vue?vue&type=script&lang=js&"
import style0 from "./base-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContactInfo: require('/usr/src/app/components/base-header/components/contact-info.vue').default,DesktopMenu: require('/usr/src/app/components/base-header/components/desktop-menu.vue').default,MobileMenu: require('/usr/src/app/components/base-header/components/mobile-menu.vue').default,ModalBase: require('/usr/src/app/components/auth-modal/modal-base.vue').default,NewTermsModal: require('/usr/src/app/components/auth-modal/new-terms-modal.vue').default,LnModal: require('/usr/src/app/components/common-sections/ln-modal.vue').default})
